<template>
    <FormSection
        :title="`Documents for ${referral.lastName}, ${referral.firstName} `"
        :full-height="false"
        :show-product-pill="true"
        :application-id="referral.application"
    >
        <template #content>
            <section class="d-flex flex-column p-3">
                <PatientDocuments
                    :patient-id="referral.id"
                    :application="referral.application"
                    :provider-id="referral.providerId"
                    :account-id="referral.accountId"
                    :upload-document="uploadDocument"
                    :delete-document="deleteDocument"
                    :get-documents="getReferralDocuments"
                    :is-palliative="isPalliative"
                    :is-referral-page="true"
                    :referral="referral"
                />
                <footer class="d-flex justify-content-center">
                    <button
                        @click="closeAddDocumentsDialog()"
                        type="button"
                        class="btn btn-xs me-2 btn-outline-primary"
                    >
                        Close
                    </button>
                </footer>
            </section>
        </template>
    </FormSection>
</template>

<script lang="ts" src="./HosPalReferralDocuments.ts" />
